import React, { useState, useReducer, useEffect } from "react";
import PortalMainPageButtons from "./PortalMainPageButtons";
import IprsPortalSvg from "./IprsPortalSvg";
import ReferralFormListAndForm from "../ReferralFormListAndForm";
import IprsPortalMIReports from "./IprsPortalMIReports";
import { decodeJWT } from "../../../lib/iprs-react-library/src";

// This function is used to redirect the users to different site.
const MyIprsHealth = () => {
    window.location.href = "https://myiprshealth.com/";
    return (
        <>
            <p>Redirecting</p>
        </>
    );
};

const intiUseNewLayout = localStorage.getItem("useNewLayout") === "true";

// Initial state to store string that will be used to switch
// between different components.
const initialState = {
    selectedPage: intiUseNewLayout ? "home" : "ReferralClientList",
    breadCrumb: "Home",
    useNewLayout: intiUseNewLayout,
};

function reducer(state, action) {
    switch (action.type) {
        case "SET_PAGE":
            return {
                ...state,
                selectedPage: action.payload.componentName,
                breadCrumb: action.payload.breadCrumb,
            };
        case "SET_DEFAULT_PAGE":
            const useNewLayout = action.payload.useNewLayout;
            localStorage.setItem("useNewLayout", useNewLayout? "true" : "false");
            return {
                ...state,
                ...initialState,
                useNewLayout: useNewLayout,
                selectedPage: useNewLayout? "home" : "ReferralClientList",
            };
        default:
            return state;
    }
}

const IprsHealthPortal = ({ api }) => {
    const [pageSettings, setPageSettings] = useState({
        selectedPage: "home",
        breadCrumb: "Home",
    });

    const [roles, setRoles] = useState(decodeJWT(api.getToken())?.roles);

    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(() => {
        console.log(state);
    }, [state]);

    useEffect(() => {
        console.log(roles);
    }, [roles]);

    // Checks "pharos" in url.
    const [currentUrl, setCurrentUrl] = useState(false);

    // Checks the url to distinguish whether it is being called from webreferral
    // or pharos to hide or show three buttons (add directory, upload files, delete files).
    // Only pharos shows all the buttons and
    useEffect(() => {
        const url = window.location.href;
        console.log("current url: ", url, url.includes("pharos"));
        setCurrentUrl(url.includes("pharos"));
    }, []);

    return (
        <>
        

        <ToggleDefaultPageButton 
                                useNewLayout={state.useNewLayout}
                                dispatch={dispatch}
                            />
            {/* <div className="background__grey iprsPortalTopDiv">
                <div className="iprsPortalBreadCrumbDiv">
                    <p>{state.breadCrumb}</p>
                </div>
                <div className="iprsPortalBreadCrumbSearchInputDiv">
                    <input defaultValue="Patient Search" />
                </div>
            </div> */}

            {/* When selectedPage  */}
            {state.selectedPage === "home" && (
                <>
                    <div className="main__section">
                        <>
                            <div className="container typography">
                                <h1>Welcome to the IPRS Health Portal</h1>
                            </div>
                            <div className="dashboard__content">
                                <div className="typography">
                                    <h2 className="text-center">
                                        <span className="green">
                                            IPRS Bulletin
                                        </span>
                                    </h2>
                                    <h3 className="text-center">
                                        <span className="green">
                                            Welcome to the NEW IPRS Health
                                            Portal and Congratulations for
                                            successfully logging on. For further
                                            assistance in using the portal
                                            please refer to Resources and Useful
                                            Documents, search our FAQs OR
                                            contact us via Live Chat!!
                                            <br />
                                        </span>
                                    </h3>
                                </div>
                            </div>

                            <PortalMainPageButtons
                                roles={roles}
                                setPageSettings={setPageSettings}
                                dispatch={dispatch}
                            />
                            <IprsPortalSvg />
                        </>
                    </div>
                </>
            )}

            {state.selectedPage !== "home" && (
                <>
                    <div>
                        {/* Button is refactored. This is a required feature for all health portal components
                    other than the "home" which is the main page of this portal.
                */}
                        {state.useNewLayout && <button
                            onClick={() => {
                                dispatch({
                                    type: "SET_PAGE",
                                    payload: {
                                        componentName: "home",
                                        breadCrumb: "Home",
                                    },
                                });
                            }}
                            className="IprsPortalBackButton"
                        >
                            {"<< Back to Home"}
                        </button>}
                    </div>

                    {state.selectedPage === "ReferralClientList" && (
                        <>
                            <ReferralFormListAndForm api={api} />
                        </>
                    )}

                    {state.selectedPage === "ViewMIReports" && (
                        <>
                            <IprsPortalMIReports
                                api={api}
                                currentUrl={currentUrl}
                            />
                        </>
                    )}

                    {state.selectedPage === "AccessMyIprsHealth" && (
                        <>
                            <MyIprsHealth />
                        </>
                    )}
                </>
            )}
        </>
    );
};

const ToggleDefaultPageButton = ({ useNewLayout, dispatch }) => {

    const handleClick = (useNewLayout) => {
        dispatch({
            type: "SET_DEFAULT_PAGE",
            payload: { useNewLayout },
        });
    };

    return (
        <button onClick={() => handleClick(!useNewLayout)} className="IprsPortalNewLayoutButton">
            {useNewLayout ? "Old Layout" : "New Layout"}
        </button>
    );
};

export default IprsHealthPortal;
